import React from 'react';
import { useAgencyDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/AgencyDashboard/store/agencyDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const AgencyHoursByProviderChart: React.FC = () => {
  const data = useAgencyDashboardStore((s) => s.hoursByProvider);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        No agency provider data available for the selected filters.
      </EmptyStateContainer>
    );
  }

  const barColor = palette.chartColors[3] || palette.chartColors[0];

  const items: HorizontalBarItem[] = data.map((d) => {
    const hours = formatDashboardNumber(d.hours);
    const shifts = d.shiftCount.toLocaleString();
    return {
      label: d.provider,
      value: d.hours,
      valueLabel: `${hours}h · ${shifts} shifts`,
      ariaLabel: `${d.provider}: ${hours} hours, ${shifts} agency shifts`,
      tooltipHtml: `<strong>${d.provider}</strong><br/>Hours: ${hours}<br/>Agency shifts: ${shifts}`,
      barColor,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      leftMargin={170}
      rightMargin={150}
      showTrack={false}
      wrapLabels
      scrollable
      ariaLabel="Agency hours by provider chart showing hours filled and shift count per external agency"
    />
  );
};
